<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="_mb-sm-50">携帯電話番号の登録変更</HeadingOne>

    <NoticeBox v-if="!hasDigits" class="-error _mb-sm-40 _mb-md-60">
      <NoticeHeader>
        <h3 class="heading">以下の内容をご確認ください。</h3>
      </NoticeHeader>
      <NoticeBody>
        <ul>
          <li>SMS送信可能な電話番号を入力してください。</li>
        </ul>
      </NoticeBody>
    </NoticeBox>

    <WizardGroup class="_mb-sm-50 _mb-md-60">
      <MainWizard :active-index="0" type="phone"></MainWizard>
    </WizardGroup>

    <p>SMS送信が利用可能な携帯電話番号を入力してください。</p>
    <section>
      <TableGroup>
        <TableBox class="_mb-10">
          <TableBody>
            <TableRow>
              <TableHeader> 電話番号（その他） </TableHeader>
              <TableData>
                <InputGroup>
                  <InputgroupAppend>
                    <InputPhone
                      id="phone"
                      :phone="{
                        phone1: userData.phone_mobile_1,
                        phone2: userData.phone_mobile_2,
                        phone3: userData.phone_mobile_3,
                      }"
                      @input="setPhone"
                    ></InputPhone>
                  </InputgroupAppend>
                  <InputLabel id="lastname_kanji"> 入力例：090-****-**** </InputLabel>
                </InputGroup>
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>

      <form novalidate @submit.prevent="submitEditProfile">
        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" @click.prevent="submitEditProfile"> 確認画面へ </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="mb001"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </form>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import { setPhoneMobile, checkMobilePhoneDigits } from "@/utils/UserData";

import HeadingOne from "@/components/heading/HeadingOne";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import InputGroup from "@/components/input/InputGroup";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import InputPhone from "@/components/input/InputPhone";
import InputLabel from "@/components/input/InputLabel";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";

export default {
  name: "Mb065",
  components: {
    BtnBack,
    BtnMain,
    BtngroupDouble,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    HeadingOne,
    BreadcrumbGroup,
    InputGroup,
    InputgroupAppend,
    InputPhone,
    InputLabel,
    MainWizard,
    WizardGroup,
    NoticeHeader,
    NoticeBox,
    NoticeBody,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
        vm.prevRoute = from
    })
  },
  setup() {
    setMeta({
      title: "電話番号登録変更",
      description: "",
      keywords: "",
    });

    return {
      setPhoneMobile,
      checkMobilePhoneDigits,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "お客さま情報の確認・変更",
          routerName: "mb023",
        },
        {
          text: "携帯電話番号の登録変更",
          active: true,
        },
      ],
      userData: {
        id_type: "",
        account_id: "",
        name_kanji: "",
        name_kana: "",
        firstname_kana: "",
        firstname_kanji: "",
        lastname_kana: "",
        lastname_kanji: "",
        bth: "",
        sex: "",
        phone_au_1: "",
        phone_au_2: "",
        phone_au_3: "",
        phone_mobile_1: "",
        phone_mobile_2: "",
        phone_mobile_3: "",
        repayment_date: "",
        contractual_repayment_cycle: "",
        postcode: "",
        address_region: "",
        address_city: "",
        address_street: "",
        address_building: "",
        address_kana: "",
        home_type: "",
        nky_ngt: "",
        rent_loan_amount: "",
        marriage_status: "",
        number_of_children: "",
      },
      isDisabled: false,
      hasDigits: true,
      prevRoute: null,
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key].toString().trim();
            }
          }
          this.setStoreData();
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    setStoreData() {
      if(
        this.$store.state.changePhoneNumber.phone_mobile_1 &&
        this.prevRoute.name === 'mb066'
      ) {
        this.userData.phone_mobile_1 = this.$store.state.changePhoneNumber.phone_mobile_1;
        this.userData.phone_mobile_2 = this.$store.state.changePhoneNumber.phone_mobile_2;
        this.userData.phone_mobile_3 = this.$store.state.changePhoneNumber.phone_mobile_3;
      } else {
        this.$store.commit("setChangePhoneNumber", {});
      }
    },
    setPhone(data) {
      this.userData = {
        ...this.userData,
        ...setPhoneMobile(data.phone1, data.phone2, data.phone3),
      };
    },
    submitEditProfile() {
      if (this.isDisabled) {
        return;
      }

      this.hasDigits = checkMobilePhoneDigits(
        this.userData.phone_mobile_1,
      );
      if (!this.hasDigits) {
        scrollTop();
        return;
      }
      
      this.isDisabled = true;
      this.$store.commit("setChangePhoneNumber", {
        phone_mobile_1: this.userData.phone_mobile_1,
        phone_mobile_2: this.userData.phone_mobile_2,
        phone_mobile_3: this.userData.phone_mobile_3
      });
      this.$router.push({ name: "mb066" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.TableData {
  > .red {
    color: $danger;
    font-weight: bold;
  }
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
.contact-box {
  > .card-body {
    justify-content: flex-start;
  }
}
</style>
